import React from 'react';
import IconAmenityShuttle from '@spothero/icons/amenity-shuttle';
import IconTrainFilled from '@spothero/icons/train-filled';
import { Flex, Icon, Box } from '@spothero/ui';
export const getTransportationDetails = (type, fastFrequency, slowFrequency) => {
    switch (type) {
        case 'scheduled':
        case 'scheduled-shuttle':
            return {
                text: slowFrequency && fastFrequency
                    ? `Shuttle every ${fastFrequency || ''} - ${slowFrequency || ''} mins`
                    : fastFrequency
                        ? `Shuttle every ${fastFrequency || ''} mins`
                        : slowFrequency
                            ? `Shuttle every ${slowFrequency || ''} mins`
                            : 'Scheduled shuttle',
                shuttleIcon: IconAmenityShuttle,
            };
        case 'on-demand':
        case 'on-demand-shuttle':
            return {
                text: 'On Demand Shuttle',
                shuttleIcon: IconAmenityShuttle,
            };
        case 'public-transit':
            return {
                text: 'Public Transit Access',
                shuttleIcon: IconTrainFilled,
            };
        default:
            return { text: '', shuttleIcon: null };
    }
};
const AirportCardTransportation = ({ transportation, }) => {
    const { text: transportationText, shuttleIcon } = getTransportationDetails(transportation?.type, transportation?.schedule?.fastFrequency, transportation?.schedule?.slowFrequency);
    if (!transportationText || !shuttleIcon) {
        return null;
    }
    const isPublicTransit = transportation?.type === 'public-transit';
    const isAlwaysOpen = !isPublicTransit && transportation?.hoursOfOperation?.alwaysOpen;
    return (<Flex gap="0.5" my="1" data-testid="AirportCardTransportation">
            <Icon mt={1} as={shuttleIcon}/>
            <Box data-testid="AirportCardTransportation-text">
                {isAlwaysOpen
            ? `${transportationText} (24/7)`
            : transportationText}
            </Box>
        </Flex>);
};
export default AirportCardTransportation;
